import { ClientApp } from "models";
import { DeleteAppEndAction } from "../actions/DeleteApp";
import { AppsMap, AppState } from "../state";

export function deleteApp(state: AppState, action: DeleteAppEndAction): AppState {
    const { appId, error } = action.payload;
    const errorMap = { ...state.errorMap };
    errorMap[action.type] = error;

    const appsMap: AppsMap = { ...state.appsMap };
    const appPagesMap = { ...state.appPagesMap };

    if (!error) {
        const filterApp = (app: ClientApp): boolean => {
            return app.appId !== appId;
        };
        Object.keys(appsMap).forEach(organizationId => {
            appsMap[organizationId] = appsMap[organizationId].filter(filterApp);
        });
        Object.keys(appPagesMap).forEach(organizationId => {
            appPagesMap[organizationId].forEach(page => {
                page.apps = page.apps.filter(filterApp);
            });
        });
    }

    return { ...state, appsMap, appPagesMap, errorMap };
}
